import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractComponent, NotificationService } from '@shared/ui';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { AuthState } from '../../states';
import { ViewStore } from '@coach-bot/data-access/shared';

@Component({
  selector: 'fu-abstract-auth',
  template: '',
})
export abstract class AbstractAuthComponent extends AbstractComponent implements AfterViewInit {
  @ViewChild('container', { read: ViewContainerRef })
  protected container: ViewContainerRef;

  error$: Subject<string> = this.authState.error$;
  loading$: BehaviorSubject<boolean> = this.viewStore.authLoading$;

  form: FormGroup;

  constructor(
    protected authState: AuthState,
    protected notificationService: NotificationService,
    protected viewStore: ViewStore,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.error$.pipe(takeUntil(this.destroyed$)).subscribe((error: string) => {
      this.notificationService.showNotification(
        error,
        'error',
        this.container,
      );
    });

    this.loading$.pipe(takeUntil(this.destroyed$)).subscribe((loading: boolean) => {
      if (loading) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    });
  }
}
